/*
 * File: validate.tsx
 * Project: a-a
 * File Created: Monday, 14th October 2024 2:22:50 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 10th December 2024 12:26:04 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
export const validatePassword = (text: string) => {
  const hasLowercase = /[a-z]/.test(text);
  const hasUppercase = /[A-Z]/.test(text);
  const hasNumber = /\d/.test(text);
  const hasSymbol = /[!@#$%^&*? "]/.test(text);
  const hasMinLength = text.length >= 8;
  // return (text.length>=8 && hasLowercase && hasUppercase && hasNumber)
  var re = /^(?=.*\d)(?=.*[!@#$%^&*? "])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return { valid: re.test(text), hasLowercase, hasUppercase, hasMinLength, hasSymbol, hasNumber };
};

export const validateEmail = (text: string) => {
  const check = text.includes('@');
  // console.log(check)
  return !check ? 'Please enter valid email' : '';
};
